import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  max-width: 90%;
  align-self: center;
  margin: 0 auto;
`;

export const YearMakeTitle = styled.h2`
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  text-align: left;
  font-size: 1rem;
  margin: 5px 0;
  text-align: center;
`;

export const Table = styled.table`
  width: 100%;
  margin: 0 0 15px 0;
  align-self: center;
  flex: 1;
`;

export const AttributesTable = styled.table`
  width: 100%;
  margin: 0 auto 15px auto;
  align-self: center;
  flex: 1;
  background-color: #424141;
`

export const Tr = styled.tr`
  padding: 15px 0;
`

export const Td = styled.td`
  text-align: ${props => props.right ? 'right' : 'center'};
  padding: 5px 0;
  ${props => props.title && 'font-weight: bold'};
  ${props => props.title && 'border-bottom: 1px #fff solid'};
`

export const TableTitle = styled.h2`
  font-size: 21px;
  text-align: center;
  font-weight: normal;
  margin: 25px 0 15px 0;
`;

export const SectionWrapper = styled.div`
  background-color: #424141;
  padding: 15px;
  margin: 15px 0;
`;

export const VGPlusLink = styled.a`
  color: white;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;
